import { render, staticRenderFns } from "./CBlockList.vue?vue&type=template&id=3d57ef10&"
import script from "./CBlockList.vue?vue&type=script&lang=ts&"
export * from "./CBlockList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports